import { render, staticRenderFns } from "./leaveOff.vue?vue&type=template&id=40a1c507&scoped=true&"
import script from "./leaveOff.vue?vue&type=script&lang=js&"
export * from "./leaveOff.vue?vue&type=script&lang=js&"
import style0 from "./leaveOff.vue?vue&type=style&index=0&id=40a1c507&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a1c507",
  null
  
)

export default component.exports